import React, { useContext } from 'react';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import themeContext from '../../../../context/theme/themeContext';

const Steps: React.FC = () => {
    const { steps, currentStep, setCurrentStep } = useContext(CreateASpoolContext);
    const { theme } = useContext(themeContext);

    const verifyPreviousStepsCompleted = (selected: number) => {
        const stepsCompletionStatus = steps
            .filter((_, index) => index < selected)
            .map((step) => step.completed);

        return !stepsCompletionStatus.includes(false);
    };

    const handleClick = (step: number) => {
        if (currentStep === step || !verifyPreviousStepsCompleted(step)) return;

        setCurrentStep(+step);
    };

    return (
        <div className={`steps-container ${theme}`}>
            {steps.length
                ? steps.map(({ label }, index) => (
                      <div className='step-container' key={index}>
                          <div
                              className={`circle ${
                                  currentStep === index + 1 ? 'active' : ''
                              } ${currentStep > index + 1 ? 'completed' : ''}`}
                              onClick={() => handleClick(index + 1)}
                          >
                              <div className='line' />
                              <div className='inner'>
                                  <span>{index + 1}</span>
                              </div>
                          </div>
                          <span>{label}</span>
                      </div>
                  ))
                : null}
        </div>
    );
};

export default Steps;
